import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (resourceId) =>
    present(
      repository
        .getResource(resourceId)
        .catch((error) => Promise.reject({ error, resourceId })),
    );
}

export type { Interactor };

export { createInteractor };
